module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre",
    attrs: {
      "id": "pgepubid00024"
    }
  }, [_vm._v("CHAPTER II")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre8 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00025"
    }
  }, [_vm._v("BAD NEWS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The girls stared wide-eyed at Betty while slowly the color drained from\ntheir faces. It was true they had been dreading just this news for a\nlong, long time, yet now that it had come they felt strangely quiet and\nnumb. They had much the same feeling as one who had received a stunning\nblow. Until the paralysis had passed there could be no pain. That would\ncome later.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"How do you know?\" asked Mollie at last, in a voice that sounded strange\neven to herself. \"Frank hasn't mentioned it.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"He will probably, toward the end,\" Betty explained, while slowly her\nheart contracted and the tears welled to her eyes. \"Allen didn't—not\ntill the last sentence. It's only a line, but th-that's enough. He says\nnot to be alarmed if his letters are delayed—it may be hard to get them\nthrough.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"They are going to the front,\" Amy repeated dazedly, as if she found it\nhard to really believe. \"When—did he say when, Betty?\""), _c('span', {
    attrs: {
      "id": "pgepubid00026",
      "title": "[12]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_12",
      "title": "[12]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"No, he didn't,\" said Betty slowly. \"But you know Allen. He wouldn't\nhave said anything about it if the time hadn't been pretty close at\nhand.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Why,\" cried Grace, catching her breath as though the thought had just\noccurred to her, \"they may be in the front line trenches now! They may\nbe—they may be—\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And while the girls gazed at her in tragic silence, imagining terrible,\nunbelievable things, a moment will be taken to sketch briefly for the\nbenefit of new readers the various exciting or amusing adventures which\nhad befallen the Outdoor Girls in the days before the grim shadow of war\nhad spread itself over the land.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In the first volume of the series, entitled \"The Outdoor Girls of\nDeepdale,\" the girls had formed a camping and tramping club and had\ntramped for miles over the country, meeting with many interesting\nadventures on the way.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("After this, one good time had followed hard on the heels of another,\nfirst at Rainbow Lake, then at a winter camp where they had novel and\ninteresting experience on skates and ice-boats.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("At Ocean View some time later the Outdoor Girls had cleared up a mystery\ncentering about a strange box they had found in the sand. Then had\nfollowed that splendid summer at Pine Island,"), _c('span', {
    attrs: {
      "id": "pgepubid00027",
      "title": "[13]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_13",
      "title": "[13]"
    }
  })]), _vm._v(" when the girls had\naccidentally discovered a gypsy cave and had succeeded not only in\nrounding up the band of gypsies but in recovering several valuable\narticles that had been stolen from them. The four boys who were now\nfacing the enemy in France had shared in their fun that summer, pitching\ncamp near the bungalow of the girls.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Their next adventure found the girls and boys again at Pine Island, but\nunder greatly altered circumstances. America had just entered the great\nwar, and the four boys had responded eagerly to the bugle call. Later\nthey were sent to Camp Liberty for training, to which the girls soon\nfollowed them to work in the Hostess House.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Will Ford, the brother of Grace, had caused the girls, and especially\nhis sister, anxiety and uneasiness because of his failure to enlist with\nthe other boys. In the end he justified himself, however, by delivering\na German spy to justice and enlisting in the service of his country\nimmediately afterward. The girls also recovered some valuable jewelry\nthat the spy had stolen from them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Then in the volume directly preceding this, entitled \"The Outdoor Girls\nat the Hostess House,\" the girls had befriended an old woman who had"), _c('span', {
    attrs: {
      "id": "pgepubid00028",
      "title": "[14]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_14",
      "title": "[14]"
    }
  })]), _vm._v("\nbeen knocked down by an unscrupulous motorcyclist. They later learned\nthe secret tragedy in the life of their little old lady.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Now the girls had come home to Deepdale for a much needed rest, only to\nbe confronted with the terrible, though, naturally, expected, news that\nthe boys had been ordered to the front.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Yes they may be, probably are, facing death at this minute,\" said\nMollie slowly, finishing the broken sentence. \"Perhaps at the very\nminute we were playing and singing and enjoying ourselves—\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Mollie, don't!\" cried Amy brokenly. \"I don't feel as if I could ever\nenjoy myself again.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Well, we've got to, whether we can or not,\" said Betty, striving to\ncontrol her quivering lips and tilting her little chin at a brave angle.\n\"We can't just lie down at the very first shot, you know.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"You talk as if we were on the firing line,\" said Grace hysterically.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"I suppose in a way we are,\" returned the Little Captain slowly, wishing\ndesperately that those troublesome tears would stay where they\nbelonged—her eyes were so misty she could hardly see Grace! \"Only ours\nis a harder kind of battle, because it's made up mostly of waiting and\nworking without any of the thrill and excite"), _c('span', {
    attrs: {
      "id": "pgepubid00029",
      "title": "[15]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_15",
      "title": "[15]"
    }
  })]), _vm._v("ment of the real fight to\nhelp us. But I'd like to know,\" and there was a little ring of pride and\nrenewed courage in her voice, \"what the real fighters would do without\nus anyway. We're just as much soldiers as they are, and if we don't do\nour share, they can't do theirs.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Of course you are right, Betty dear, you always are!\" cried Mollie,\ntaking heart and even smiling a little. \"We can't do anybody good by\nmoping.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"No,\" added Grace with a philosophy unusual in her. \"That's why we have\nthe hardest share, I guess—because we have to keep gay and bright, no\nmatter how we feel.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"And we still have our work at the Hostess House,\" Amy reminded them.\n\"Maybe,\" she added, a little wistfully, \"if we work hard enough we'll be\nable to forget—\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"What's all this about working and forgetting?\" cried Mrs. Nelson,\ncoming gayly into the room. \"I thought you had come home for a\nvacation.\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The girls explained, and Mrs. Nelson looked pityingly at their grave\nyoung faces.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"So that is it,\" she was beginning, when Mollie sprang to her feet with\na cry. She was staring at the paper that Mrs. Nelson had carelessly\nthrown on the table."), _c('span', {
    attrs: {
      "id": "pgepubid00030",
      "title": "[16]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_16",
      "title": "[16]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"What is it?\" they cried, as she snatched it up and read the glaring\nheadlines.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"The Hostess House!\" gasped Mollie. \"Gone! Burnt up! Read this!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Dazedly the girls obeyed, the big type seeming to strike them in the\nface as they read:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("\"Great Fire at Camp Liberty! Hostess House and Several Barracks\nBuildings Burned to the Ground!\""), _c('span', {
    attrs: {
      "id": "pgepubid00031",
      "title": "[17]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_17",
      "title": "[17]"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "calibre_pb_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0